module.exports = __webpack_public_path__ + "img/dp.496903fd.jpg";